import React from "react";
import "@/App.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Landing from "./pages/Landing";

function App() {
  return (
    <div className="App min-h-screen bg-ink text-ivory">
      <Header />
      <Landing />
      <Footer />
    </div>
  );
}

export default App;
